import useAuth from '@/hooks/useAuth';

// V2 Order Flow is restricted to tenant admins only.

const useOrderFlowV2Enabled = (): boolean => {
  const { currentAdmin, currentAdminIsCustomerAdmin } = useAuth();
  if (!currentAdmin) return false;

  // Only tenant admins can use v2
  return !currentAdminIsCustomerAdmin;
};

export default useOrderFlowV2Enabled;
